'use client'

import { Button } from '@/components/ui/button'
import { limitResetsOnLabel } from './limit-card-utils'

export function LimitCardFooter({
  amount,
  sublabel,
  onChangeLimit,
  changeLimitControl,
  changeLimitDisabled = false,
}: {
  amount: React.ReactNode
  sublabel: string
  onChangeLimit?: () => void
  changeLimitControl?: React.ReactNode
  changeLimitDisabled?: boolean
}) {
  const button = changeLimitControl ?? (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onChangeLimit}
      disabled={changeLimitDisabled || !onChangeLimit}
    >
      Change limit
    </Button>
  )

  return (
    <>
      <div className="flex flex-wrap items-baseline gap-3">
        <span className="bv3-bigmono tabular-nums">{amount}</span>
        <span className="text-sm text-text-muted">{sublabel}</span>
      </div>
      <div className="mt-4 flex items-center justify-between gap-3">
        <div className="text-[13px] text-text-muted">
          Resets on {limitResetsOnLabel()}
        </div>
        {button}
      </div>
    </>
  )
}
